import { Box, Button, Container, Stack, Typography } from '@mui/material';

interface AppErrorFallbackProps {
  error: unknown;
  resetError: () => void;
}

/**
 * Last-resort UI for an unhandled render error, shown by Sentry.ErrorBoundary.
 * Rendered outside ThemeProvider (the boundary sits above it), so it relies on
 * MUI's default theme — keep it self-contained.
 */
export const AppErrorFallback = ({ error, resetError }: AppErrorFallbackProps) => {
  const message =
    error instanceof Error ? error.message : 'An unexpected error occurred.';
  return (
    <Box component="main" sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
      <Container maxWidth="sm">
        <Stack spacing={2} alignItems="flex-start">
          <Typography variant="h5" component="h1">
            Something went wrong
          </Typography>
          <Typography color="text.secondary">
            The page hit an unexpected error. You can try again; if it keeps
            happening, contact support with the time it occurred.
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ wordBreak: 'break-word' }}>
            {message}
          </Typography>
          <Button variant="contained" onClick={resetError}>
            Try again
          </Button>
        </Stack>
      </Container>
    </Box>
  );
};
